import React, { useState } from 'react';
import { observer } from 'mobx-react';
import type OrderItem from '@this/domain/order_item2';
import { updateOrderItemWaiting } from '@this/components/arrangement/shared/update_order_item_waiting';

interface Props {
  orderItem: OrderItem;
}

export const OrderItemWaitingSelect = observer(({ orderItem }: Props) => {
  const [saving, setSaving] = useState(false);

  const handleChange = (value: boolean) => {
    setSaving(true);
    updateOrderItemWaiting(orderItem, value).finally(() => {
      setSaving(false);
    });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: '5px' }}>引き継ぎ:</span>
      {saving ? (
        <span>保存中...</span>
      ) : (
        <select
          onChange={e => handleChange(e.target.value === 'true')}
          value={orderItem.waiting?.toString() ?? 'false'}
          style={{ marginBottom: '0px' }}
        >
          <option value="true">◯</option>
          <option value="false">×</option>
        </select>
      )}
    </div>
  );
});
